import React from 'react';
import PropTypes from 'prop-types';
import withToolboxTourTooltip from 'SelfServeTooltipTour/withToolboxTourTooltip';

export class SignatureToolboxTooltip extends React.PureComponent {
  render() {
    return (
      <div className="tooltip-contents">
        {this.props.sections.map(section => (
          <div className="signature-section">
            <div className="section-text" >
              {section.text}
            </div>
            <img
              className="section-image"
              src={section.image}
              alt=""
            />
          </div>
        ))}
        {!this.props.isToolboxTourHidden &&
          <button
            className="hide-all-tips-button"
            onClick={this.props.hideAllToolboxTips}
          >
            Hide All Tips
          </button>
        }
      </div>
    );
  }
}

SignatureToolboxTooltip.propTypes = {
  isToolboxTourHidden: PropTypes.bool.isRequired,
  hideAllToolboxTips: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
  })).isRequired,
};

export default withToolboxTourTooltip(SignatureToolboxTooltip);



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/SignatureToolboxTooltip.jsx